import { render, staticRenderFns } from "./OutboundIndex.vue?vue&type=template&id=43e5f4a4&scoped=true"
import script from "./OutboundIndex.vue?vue&type=script&lang=js"
export * from "./OutboundIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e5f4a4",
  null
  
)

export default component.exports